import { render } from "./products.vue?vue&type=template&id=4fd05ed0&scoped=true&ts=true"
import script from "./products.vue?vue&type=script&lang=ts"
export * from "./products.vue?vue&type=script&lang=ts"

import "./products.vue?vue&type=style&index=0&id=4fd05ed0&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd05ed0"]])

export default __exports__